<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          
          <!-- Modal -->
          <div class="qr_modal" id="iconModal" tabindex="-1" v-if="active_qr">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h3 style="margin-bottom: 0;">QR scan articule</h3>
                </div>
                <div class="modal-body">
                  <p class="">
                    <!--Last result: <b>{{ result_qr }}-->
                    <p v-if="cam_loading">Running...</p>
                    <p v-if="noFrontCamera">You don't seem to have a front camera on your device</p>
                    <p v-if="noRearCamera">You don't seem to have a rear camera on your device</p>
                    </b>
                  </p>
                  <!--<button type="button" @click="switchCamera">
                    <img src="../../assets/img/camerabtn.svg" alt="change camera" >
                  </button>
                  <button type="button" @click="reloadcam">
                    <span class="btn-label"><i class="nc-icon nc-refresh-69"></i></span>
                  </button>-->
                  <qrcode-stream :track="true" :camera="camera" @decode="onDecode" @init="onInit" v-if="!destroyed_cam"></qrcode-stream>
                  <!--<qrcode-capture @decode="onDecodefileload" />-->
                </div>

                <div class="modal-footer" >
                  <button type="button" id="closeqr" class="btn btn-danger" @click="active_qr = false">
                    <span class="btn-label"><i class="nc-icon nc-simple-remove"></i> Close camera</span>
                  </button>
                </div>
              
              </div>
            </div>
          </div>
          <!-- Modal -->

          <div class="row">
            <div class="col-md-12">
              <div class="card" style="margin-bottom: 10px !important;">
                <div class="card-body">
                  <div class="row">

                    <div class="col-md-3">
                      <div class="form-group">
                        <label>{{ $t('label.articule')}}</label>
                        <input
                          aria-describedby="addon-right addon-left"
                          type="text"
                          :placeholder="$t('label.articule')"
                          class="form-control"
                          value=""
                          @keyup="findArticle()"
                          v-model="drawingRequest.article"
                        />
                        <a class="scan_btn" @click="active_qr = true">
                          <i class="nc-icon nc-camera-compact"></i>
                        </a>
                        <div
                          :is-visible="isShowArticle"
                          class="btn-group bootstrap-select show-tick show"
                          style="position: static!important;"
                        >
                          <div
                            class="dropdown-menu open show"
                            role="combobox"
                            x-placement="bottom-start"
                            style="max-height: 238px; overflow: hidden;
                                  position: absolute; transform: translate3d(-46px, 48px, 0px); 
                                  top: 0px; left: 0px; will-change: transform;
                                  margin-top: 19px !important; margin-left: 4% !important;"
                          >
                            <ul
                              class="dropdown-menu inner"
                              role="listbox"
                              aria-expanded="true"
                              style="max-height: 238px; overflow-y: auto;"
                            >
                              <li
                                data-original-index="0"
                                v-for="(item, index) in listForArticles"
                                :key="index"
                              >
                                <a
                                  tabindex="-1"
                                  class
                                  data-tokens="null"
                                  role="option"
                                  href="#"
                                  aria-disabled="true"
                                  aria-selected="false"
                                  @click="selectArticle(item)"
                                >
                                  <span class="text">{{ item.article }}</span>
                                  <span class="glyphicon glyphicon-ok check-mark"></span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <div class="form-group">
                        <label>{{ $t('label.designer-name')}}</label>
                        <input
                          type="text"
                          label="Designer name"
                          :placeholder="$t('label.designer-name')"
                          class="form-control"
                          @keyup="findDesignName()"
                          v-model="drawingRequest.designerName"
                        />
                        <div
                          :is-visible="isShowDrawing"
                          class="btn-group bootstrap-select show-tick show"
                          style="position: static!important;"
                        >
                          <div
                            class="dropdown-menu open show"
                            role="combobox"
                            x-placement="bottom-start"
                            style="max-height: 238px; overflow: hidden;
                                  position: absolute; transform: translate3d(-46px, 48px, 0px); 
                                  top: 0px; left: 0px; will-change: transform;
                                  margin-top: 19px !important; margin-left: 4% !important;"
                          >
                            <ul
                              class="dropdown-menu inner"
                              role="listbox"
                              aria-expanded="true"
                              style="max-height: 238px; overflow-y: auto;"
                            >
                              <li
                                data-original-index="0"
                                v-for="(item, index) in listForDrawing"
                                :key="index"
                              >
                                <a
                                  tabindex="-1"
                                  class
                                  data-tokens="null"
                                  role="option"
                                  href="#"
                                  aria-disabled="true"
                                  aria-selected="false"
                                  @click="selectDesignName(item)"
                                >
                                  <span class="text">{{ item.names }}</span>
                                  <span class="glyphicon glyphicon-ok check-mark"></span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label>{{ $t('label.name-nomenclature')}}</label>
                        <input
                          type="text"
                          label="Nomenclature"
                          :placeholder="$t('label.name-nomenclature')"
                          class="form-control"
                          v-model="drawingRequest.nomenclature"
                          @keyup="findNomenclature()"
                        />
                        <div
                          :is-visible="isShowNomenclature"
                          class="btn-group bootstrap-select show-tick show"
                          style="position: static!important;"
                        >
                          <div
                            class="dropdown-menu open show"
                            role="combobox"
                            x-placement="bottom-start"
                            style="max-height: 238px; overflow: hidden;
                                  position: absolute; transform: translate3d(-46px, 48px, 0px); 
                                  top: 0px; left: 0px; will-change: transform;
                                  margin-top: 19px !important; margin-left: 4% !important;"
                          >
                            <ul
                              class="dropdown-menu inner"
                              role="listbox"
                              aria-expanded="true"
                              style="max-height: 238px; overflow-y: auto;"
                            >
                              <li
                                data-original-index="0"
                                v-for="(item, index) in listForNomenclature"
                                :key="index"
                              >
                                <a
                                  tabindex="-1"
                                  class
                                  data-tokens="null"
                                  role="option"
                                  href="#"
                                  aria-disabled="true"
                                  aria-selected="false"
                                  @click="selectNomenclature(item)"
                                >
                                  <span class="text">{{ item.names }}</span>
                                  <span class="glyphicon glyphicon-ok check-mark"></span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <button
                          class="btn btn-info"
                          style="margin-top: 26px !important;"
                          @click="findDrawing"
                        >{{ $t('label.find-drawing')}}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="card" style="margin-bottom: 0;">
                    <div class="card-body">
                      <div class="row d-flex justify-content-center">
                        
                        <div
                          class="dataTables_paginate paging_full_numbers"
                          id="datatable_paginate"
                        >
                          <!-- <ul class="pagination">
                            <li
                              class="paginate_button page-item"
                              v-for="key in countPage"
                              :key="key"
                              v-bind:class="{ active: key==currentPage }"
                            >
                              <a
                                href="#"
                                aria-controls="datatable"
                                data-dt-idx="3"
                                tabindex="0"
                                class="page-link"
                                @click="changePage(key)"
                              >{{ key }}</a>
                            </li>
                          </ul> -->
                          <ul class="pagination">
                            <li class="paginate_button page-item" v-if="currentPage > 1">
                              <a class="page-link" @click="currentPage--"><i class="nc-icon nc-minimal-left"></i></a>
                            </li>
                            
                            <li class="paginate_button page-item" v-bind:class="{ active: page==currentPage }" v-for="(page, index) in pagination" :key="index" >
                              <a v-if="page != '...'" class="page-link" @click="changePage(page)">{{page}}</a>
                              <a v-else class="page-link" :id="index">{{page}}</a>
                            </li>
                            
                            <li class="paginate_button page-item" v-if="currentPage < countPage">
                              <a class="page-link" @click="currentPage++"><i class="nc-icon nc-minimal-right"></i></a>
                            </li>
                          </ul>

                        </div>

                      </div>
                    </div>
                    <div
                      id="datatable_wrapper"
                      class="dataTables_wrapper container-fluid dt-bootstrap4"
                      style="margin-bottom: 10px !important;"
                    >
                      <div class="row">
                        <div class="col-sm-12 col-md-6">
                          <div class="dataTables_length" id="datatable_length"></div>
                        </div>

                        <div class="col-sm-12 col-md-6">
                          <div id="datatable_filter" class="dataTables_filter"></div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <a href="#" class="card-drawing" @click="getBigDrawing()">
                            <img class="img-aricle" src="../../assets/img/drawprewiew.jpg" v-if="!showPdf" />
                            <div>
                              <pdf
                                style="width: 100%; height: 100%;"
                                v-if="showPdf"
                                ref="myPdfComponent"
                                :src="url"
                                :page="currentPage"
                              ></pdf>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="row d-flex justify-content-center">
                        <div class="dataTables_paginate paging_full_numbers">
                          <ul class="pagination">
                            <li class="paginate_button page-item">
                              <a
                                href="#"
                                aria-controls="datatable"
                                style="font-size: 12px;"
                                data-dt-idx="3"
                                tabindex="0"
                                class="page-link"
                              >{{ nameFileTitle }}</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <!-- end content-->
                  </div>
                  <!--  end card  -->
                </div>
                <!-- end col-md-12 -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal
      name="big-drawing"
      style="z-index: 10000;"
      draggable=".window-header"
      :adaptive="true"
      :delay="300"
      :height="'90%'"
      :width="'90%'"
      :resizable="true"
      @opened="handleOpenedModal()"
      class="card-drawing">
      <div class="window-header">
        <div slot="top-right" class="text-center" style="cursor:pointer;">

          <div class="d-flex flex-row justify-content-center">

            <div class="btn-group">
              <button type="button" id="decrease" class="btn btn-info btn-round"><i class="nc-icon nc-simple-delete"></i></button> 
              <button type="button" id="increase" class="btn btn-warning btn-round"><i class="nc-icon nc-simple-add"></i></button>
              <button type="button" v-if="showPdf" @click="printPDF()" class="btn btn-round"><i class="nc-icon nc-cloud-download-93"></i> print</button>
              <a :href="url_save" v-if="showPdf" :download="currentFile" class="btn btn-success btn-round"><i class="nc-icon nc-cloud-download-93"></i> save file </a>
            </div>
            <div class="dataTables_paginate paging_full_numbers">
              <ul class="pagination" style="margin: revert;">
                <li class="paginate_button page-item" v-if="currentPage > 1">
                  <a class="page-link" @click="currentPage--"><i class="nc-icon nc-minimal-left"></i></a>
                </li>
                
                <li class="paginate_button page-item" v-bind:class="{ active: page==currentPage }" v-for="(page, index) in pagination" :key="index" >
                  <a v-if="page != '...'" class="page-link" @click="changePage(page)">{{page}}</a>
                  <a v-else class="page-link" :id="index">{{page}}</a>
                </li>
                
                <li class="paginate_button page-item" v-if="currentPage < countPage">
                  <a class="page-link" @click="currentPage++"><i class="nc-icon nc-minimal-right"></i></a>
                </li>
              </ul>
            </div>

            <div style="position: absolute; right: 0;">
              <button @click="$modal.hide('big-drawing')" class="btn btn-danger">
                <i class="nc-icon nc-simple-remove"></i>
              </button>
            </div>
          </div>

        </div>
      </div>

      <div class="card" id="schema-container" style="overflow: scroll; height: calc(100% - 40px); width: 100%; cursor: pointer;">

        

        <pdf
          ref="myPdfComponentPopup"
          :src="url_save"
          :page="currentPage"
          id="g1"
          class="pdf-viewer__preview"
          style="display: inline-block;"
        ></pdf>
      </div>
    </modal>
    
    <loader :is-visible="isLoading"></loader>
  </div>
</template>

<script>
import { saveAs } from "file-saver";
import pdf from "vue-pdf";
import printJS from 'print-js';
import { QrcodeStream,QrcodeDropZone,QrcodeCapture } from 'vue-qrcode-reader';
import Loader from "./../../components/Loader.vue";

export default {
  components: {
    pdf,
    Loader,
    printJS,
    QrcodeStream,
    QrcodeCapture,
    QrcodeDropZone
  },

  data() {
    return {
      url: "",
      url_save: "",
      documentError: undefined,
      enableUploader: false,
      pages: [],
      currentPage: 1,
      nameFileTitle: "",
      countPage: 0,
      currentFile: 0,
      i: 1,
      showPdf: false,
      isActive: false,
      isShowArticle: false,
      isShowNomenclature: false,
      isShowDrawing: false,
      isLoading: false,
      isActive:false,

      items: [],
      options: {
        multiple: true,
        checkbox: false
      },
      filter: {
        plainList: true
      },
      drawingRequest: {
        article: "",
        designerName: "",
        nomenclature: "",
        organization: "1",
        session: ""
      },

      drawingRequestPDF: {
        article: "",
        designerName: "",
        nomenclature: "",
        organization: "1",
        session: ""
      },

      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      },

      listForArticles: [],
      listForDrawing: [],
      listForNomenclature: [],
      listFiles: [],

      selectedArticle: null,

      //camera
      camera: 'auto',
      result_qr: null,
      cam_loading: false,
      active_qr: false,
      destroyed_cam: false,
      noRearCamera: false,
      noFrontCamera: false,
      //camera
    };
  },

  created() {},

  destroyed() {},

  methods: {
    printPDF(){   
      if ((this.url_save != "") && (pdf.src != "")){
        let dataB = (this.url_save).split(',')[1];
        printJS ({
          printable: dataB,
          type: 'pdf',
          base64: true
        });

        /*let iframe = "<iframe width='100%' height='100%' src='" + this.url + "'></iframe>"
        let x = window.open();
        x.document.open();
        x.document.write(iframe);
        x.document.close();*/

      }
    },
    handleOpenedModal() {

      let container = document.getElementById("schema-container");
      let move = false;
      let x, y;

      let timer = null;
      let startX, startY;

      const rect = container.getBoundingClientRect();

      container.addEventListener("mousedown", e => {
        move = true;
        startX = e.clientX - rect.left;
        startY = e.clientY - rect.top;
      });

      container.addEventListener("mousemove", e => {

        clearTimeout(timer);

        if (move) {

          let moveX = e.clientX - rect.left;
          let moveY = e.clientY - rect.top;

          let posX;
          let posY;

          let left, top;
          let step = 10;

          timer = setInterval(() => {

            posX = container.scrollLeft;
            posY = container.scrollTop;
              
            top = (moveY > startY) ? posY + step : posY - step;
            left = (moveX > startX) ? posX + step : posX - step;

            container.scrollTo({
              left: parseInt(left),
              top: parseInt(top),
            });

          }, 25);
        }
      });


      container.addEventListener("mouseup", e => {
        move = false;
      });

      const increase = document.getElementById("increase");
      const decrease = document.getElementById("decrease");

      increase.addEventListener("click", e => {
        move = false;
        let object = document.getElementsByClassName("pdf-viewer__preview")[0];
        let width = object.clientWidth;
        object.style.width = `${width + 50}px`;
      });

      decrease.addEventListener("click", e => {
         move = false;
        let object = document.getElementsByClassName("pdf-viewer__preview")[0];
        let width = object.clientWidth;
        object.style.width = `${width - 50}px`;
      });
    },

    findArticle() {
      this.listForArticles = [];
      this.listForNomenclature = [];
      this.listForDrawing = [];

      this.drawingRequest.session = localStorage.getItem("user-token");
      axios
        .post("/drawing/find-article", {
          drawingRequest: this.drawingRequest
        })
        .then(res => {
          this.listForArticles = res.data;
          this.isShowArticle = true;
        })
        .catch(e => {});
    },

    findNomenclature() {
      this.listForArticles = [];
      this.listForNomenclature = [];
      this.listForDrawing = [];

      this.drawingRequest.session = localStorage.getItem("user-token");
      axios
        .post("/drawing/find-article", {
          drawingRequest: this.drawingRequest
        })
        .then(res => {
          this.listForNomenclature = res.data;
          this.isShowNomenclature = true;
        })
        .catch(e => {});
    },

    findDesignName() {
      this.listForArticles = [];
      this.listForNomenclature = [];
      this.listForDrawing = [];

      this.drawingRequest.session = localStorage.getItem("user-token");
      axios
        .post("/drawing/find-article", {
          drawingRequest: this.drawingRequest
        })
        .then(res => {
          console.log(res);
          this.listForDrawing = res.data;
          this.isShowDrawing = true;
        })
        .catch(e => {});
    },

    selectArticle(item) {
      this.drawingRequest.article = item.article;
      this.drawingRequest.nomenclature = item.names;
      this.drawingRequest.designerName = item.designername;
      this.listForArticles = [];
      this.isShowArticle = false;

      this.getDrawingPdf(item.article);
    },

    selectNomenclature(item) {
      this.drawingRequest.article = item.article;
      this.drawingRequest.nomenclature = item.names;
      this.drawingRequest.designerName = item.designername;
      this.listForNomenclature = [];
      this.isShowNomenclature = false;

      this.getDrawingPdf(item.article);
    },

    selectDesignName(item) {
      this.drawingRequest.article = item.article;
      this.drawingRequest.nomenclature = item.names;
      this.drawingRequest.designerName = item.designername;
      this.listForDrawing = [];
      this.isShowDrawing = false;

      this.getDrawingPdf(item.article);
    },

    findDrawing() {
      console.log("findDrawing");

      if (this.drawingRequest.article == ""){
         this.showNotify("info", "Info", "Поле артикула незаповнено");
         return false;
      }

      this.isLoading = true;
      this.clearPdfView();
      this.drawingRequest.session = localStorage.getItem("user-token");
      axios
        .post("/drawing/getTreeStructure", {
          drawingRequest: this.drawingRequest
        })
        .then(res => {
          console.log(res);
          if (res.data != null) {
            const list = res.data[0];
            const tree = this.$refs.tree.tree;
            let model = tree.setModel(list);
            //this.$set(this.$refs.tree, "model", model);
          } else {
            this.showNotify(
              "error",
              "Error",
              "Структуру по даному артикулу не знайдено."
            );
          }

          this.isLoading = false;
        })
        .catch(e => {
          this.isLoading = false;
          this.showNotify("error", "Error", e);
        });
    },

    getDrawingPdf(article) {

      console.log("getDrawingPdf")
      this.isLoading = true;
      this.drawingRequestPDF.article = article;
      this.drawingRequestPDF.session = localStorage.getItem("user-token");
      this.isActive = !this.isActive;
      axios
        .post("/drawing/getDrawingPdf", {
          drawingRequest: this.drawingRequestPDF
        })
        .then(res => {
          if (res.data.status) {
            this.listFiles = res.data;
            this.showPdf = true;
            this.url = "";
            this.url_save = "";
            this.currentFile = "";

            this.url = "data:application/pdf;base64," + res.data.dataPDF;
            this.url_save = "data:application/pdf;base64," + res.data.dataPDF;

            this.currentFile = res.data.nameFile;
            this.nameFileTitle =
              " " + res.data.revision + " " + res.data.revisionNumber;
            /*let loadingTask = pdf.createLoadingTask(this.url);
            loadingTask.then(pdf => {
              this.countPage = pdf.numPages;
              this.currentFile = file;
            });*/
            let loadingTask = pdf.createLoadingTask(this.url);
            this.url = loadingTask;
            this.url.promise.then(pdf => {
              this.countPage = pdf.numPages;
              this.currentPage = 1;
            });
          } else {
            this.clearPdfView();
            this.showNotify("info", "Info", res.data.error);
          }
          
        })
        .catch(e => {
          this.showNotify("error", "Error", e);
        })
        .then(() => {
          this.isLoading = false;
        })
    },

    downloadArhivDrawing() {
      console.log(this.drawingRequest);

      this.isLoading = true;
      this.drawingRequestPDF.session = localStorage.getItem("user-token");
      axios
        .post(
          "/drawing/getDrawingArhivePdf",
          {
            drawingRequest: this.drawingRequest
          },
          {
            responseType: "arraybuffer",
            headers: { "Content-Type": "application/zip" }
          }
        )
        .then(res => {
          var data = new File(
            [res.data],
            this.drawingRequest.article + ".zip",
            {
              type: "application/zip"
            }
          );
          saveAs(data, this.drawingRequest.article + ".zip", { autoBom: true });

          this.isLoading = false;
        })
        .catch(e => {
          this.isLoading = false;
          this.showNotify("error", "Error", e);
        });
    },

    saveByteArray(data, name) {
      let str2bytes = str => {
        let bytes = new Uint8Array(str.length);
        for (let i = 0; i < str.length; i++) {
          bytes[i] = str.charCodeAt(i);
        }
        return bytes;
      };

      let a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      // let blob = new Blob([data], {type: "octet/stream"}),
      let blob = new Blob([data], { type: "application/zip" }),
        url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = name;
      a.click();
      window.URL.revokeObjectURL(url);
    },

    changePage(numPage) {
      this.isLoading = true;
      this.currentPage = numPage;
      this.isLoading = false;
    },

    changeFile(file, dataPDF) {
      this.url = "data:application/pdf;base64," + dataPDF;
      this.url_save = "data:application/pdf;base64," + dataPDF;
      /*let loadingTask = pdf.createLoadingTask(this.url);
      loadingTask.then(pdf => {
        this.countPage = pdf.numPages;
        this.currentFile = file;
      });*/
      let loadingTask = pdf.createLoadingTask(this.url);
      this.url = loadingTask;
      this.url.promise.then(pdf => {
        this.countPage = pdf.numPages;
        this.currentPage = 1;
      });
    },

    clearPdfView() {
      console.log("clearPdfView");
      this.showPdf = false;
      this.listFiles = [];
      this.url = "";
      this.url_save = "";
    },

    downloadDrawingPdf() {},

    getBigDrawing() {
      //ref="myPdfComponentPopup" src=this.url / this.url_save
      this.show();
    },

    show() {
      this.$modal.show("big-drawing", {
        title: "Drawing!",
        text: "You are too awesome",
        buttons: [
          {
            title: "Close"
          }
        ]
      });
    },

    hide() {
      this.$modal.hide("hello-world");
    },

    showNotify(group, title, messages) {
      this.$notify({
        group: group,
        title: title,
        text: messages
      });
    },
    //camera qr
    async onInit (promise) {
      this.cam_loading = true;
      try {
        await promise
      } catch (error) {
        const triedFrontCamera = this.camera === 'front'
        const triedRearCamera = this.camera === 'rear'
        const cameraMissingError = error.name === 'OverconstrainedError'
        if (triedRearCamera && cameraMissingError) {
          this.noRearCamera = true;
        }
        if (triedFrontCamera && cameraMissingError) {
          this.noFrontCamera = true;
        }
        console.error(error);
      } finally {
        this.cam_loading = false; 
      }
    },
    turnCameraOn () { this.camera = 'auto' },
    turnCameraOff () { this.camera = 'off' },
    async reloadcam () {
      this.destroyed_cam = true;
      await this.$nextTick();
      this.destroyed_cam = false;
    },
    switchCamera () {
      switch (this.camera) {
        case 'front': this.camera = 'rear'
        break
        case 'rear': this.camera = 'front'
        break
      }
    },
    onDecode (result) {
      this.result_qr = result;
      let froms = (this.result_qr).indexOf('!');

      if (froms !== -1){
        let len_str = this.result_qr.length;
        let tos = (this.result_qr).indexOf('&');

        if ((tos !== -1) && (froms < tos)){
          let new_min = this.result_qr.slice((froms + 1),tos); //"102718308"
          this.result_qr = new_min.slice(0,4) + '-' + new_min.slice(4,7) + '-' + new_min.slice(7,new_min.length);
        }
      }
      //"!102718308&1$1#2%2^H"
      //"1027-183-08" !  &

      if ((this.result_qr != null) && ((this.result_qr).length < 20)){
        this.drawingRequest.article = this.result_qr;
        this.getDrawingPdf(this.drawingRequest.article);
      }
      document.getElementById('closeqr').click();
    },
     //camera qк
  },
  watch: {
    //listForArticles: function 
  },
  computed: {
    pagination: function(){
        let arr = [];
        for (let i = 0; i < this.countPage; i++) { 
            arr[i] = i + 1;
        }
        let divider = Math.trunc(5/2);
        let start = this.currentPage - divider;
        let end = this.currentPage + divider + 1;
        if (start < 0) {
            start = 0;
        }
        let final_arr = arr.slice(start,end);
        if ((start + 1) > arr[0]){
            final_arr.unshift('...');
        }
        if(end < arr[arr.length - 1]){
            final_arr.push('...');
        }
        return final_arr;
    },
  },
};
</script>

<style scoped>
  .ico_print::before{
    content: '\f029';
  }
  .qr_modal{
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 1050;
    outline: 0;
    background: #00000085;
  }
  .scan_btn{
    position: absolute;
    top: 35%;
    right: 6%;
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/pages/Drawing/Article.vue